export default "__VITE_ASSET__PIWCYhuT__"